import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

let currentScroll = 0;
let isScrollingDown = true;
let lastScrollY = window.scrollY;
let lastTimestamp = performance.now();

const tween = gsap
  .to('.text-marquee__part', {
    xPercent: -100,
    repeat: -1,
    duration: 50,
    ease: 'linear',
  })
  .totalProgress(0.5);

gsap.set('.text-marquee', { xPercent: -50 });

let speedScale = 1;

window.addEventListener('scroll', function () {
  const scrollY = window.scrollY;
  if (scrollY >= currentScroll) {
    isScrollingDown = true;
  } else {
    isScrollingDown = false;
  }
  // isScrollingDown = true;

  const timestamp = performance.now();
  const timeElapsed = timestamp - lastTimestamp;
  let speedMultiplier = 1;

  if (timeElapsed > 0) {
    const scrollDistance = Math.abs(scrollY - lastScrollY);
    const scrollSpeed = scrollDistance / timeElapsed;
    speedMultiplier = 1 + scrollSpeed * 10;
    lastScrollY = scrollY;
    lastTimestamp = timestamp;
  }

  speedScale = speedMultiplier * (isScrollingDown ? 1 : -1);

  gsap.to(tween, {
    timeScale: speedScale,
  });

  currentScroll = scrollY;
});

window.setInterval(function () {
  if (
    lastTimestamp < performance.now() - 500 &&
    (speedScale > 1 || speedScale < -1)
  ) {
    if (speedScale > 0) {
      speedScale -= 4;
      if (speedScale < 1) speedScale = 1;
    }
    if (speedScale < 0) {
      speedScale += 4;
      if (speedScale > -1) speedScale = -1;
    }
    gsap.to(tween, {
      timeScale: speedScale,
    });
  }
}, 100);
